<app-thi-page-shell [lang]="landingLang">
  <div>
    <!-- Hero -->
    <section class="relative pt-40 pb-24 thi-section-gradient-soft overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-4xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">{{ t.pricing.title }}</h1>
          <p class="text-xl text-muted-foreground">{{ t.pricing.subtitle }}</p>
        </div>
      </div>
    </section>

    <app-thi-public-pricing
      [lang]="landingLang"
      [showSectionHeader]="false"
      [registerLink]="registerLink"
    ></app-thi-public-pricing>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- SECTION: Extensions — Doc + Company packs            -->
    <!-- ══════════════════════════════════════════════════════ -->
    <section
      class="sp-section"
      *ngIf="
        !plansLoading &&
        !plansError &&
        (docExtensionPlans.length > 0 || companyExtensionPlans.length > 0)
      "
    >
      <div class="sp-section-inner">
        <div class="sp-section-header">
          <div class="sp-section-icon sp-section-icon--ext">
            <i class="fa fa-plus-circle"></i>
          </div>
          <div>
            <h2 class="sp-section-title">{{ t.pricing.addOnsTitle }}</h2>
            <p class="sp-section-desc">
              {{ landingLang === 'ar'
                ? 'تحتاج مستندات أو شركات أكثر؟ أضفها في أي وقت لخطتك الحالية.'
                : landingLang === 'he'
                  ? 'צריך עוד מסמכים או חברות? הוסף אותם בכל עת לתוכנית הקיימת שלך.'
                  : 'Need more documents or companies? Add them anytime to your existing plan.' }}
            </p>
          </div>
        </div>

        <div class="row g-4 justify-content-center">
          <!-- Doc extension cards -->
          <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of docExtensionPlans; trackBy: trackByAddonId">
            <div class="sp-ext-card sp-ext-card--doc">
              <div class="sp-ext-card__icon"><i class="fa fa-files-o"></i></div>
              <div class="sp-ext-card__badge">{{ docPackBadge(plan.extra_documents) }}</div>
              <h4 class="sp-ext-card__name">{{ addonDisplayName(plan) }}</h4>
              <p class="sp-ext-card__desc" *ngIf="addonDesc(plan)">{{ addonDesc(plan) }}</p>
              <div class="sp-ext-card__value">+{{ plan.extra_documents }}</div>
              <div class="sp-ext-card__label">
                {{ landingLang === 'ar' ? 'مستند إضافي' : landingLang === 'he' ? 'מסמכים נוספים' : 'extra documents' }}
              </div>
              <div class="sp-ext-card__price">₪{{ plan.price | number:'1.0-0' }}</div>
              <a class="sp-btn sp-btn--outline w-100 mt-2" [routerLink]="registerLink">
                {{ t.hero.ctaPrimary }}
              </a>
            </div>
          </div>

          <!-- Company extension cards -->
          <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of companyExtensionPlans; trackBy: trackByAddonId">
            <div class="sp-ext-card sp-ext-card--company">
              <div class="sp-ext-card__icon"><i class="fa fa-building"></i></div>
              <div class="sp-ext-card__badge sp-ext-card__badge--blue">{{ companyPackBadge(plan.extra_companies) }}</div>
              <h4 class="sp-ext-card__name">{{ addonDisplayName(plan) }}</h4>
              <p class="sp-ext-card__desc" *ngIf="addonDesc(plan)">{{ addonDesc(plan) }}</p>
              <div class="sp-ext-card__value sp-ext-card__value--blue">+{{ plan.extra_companies }}</div>
              <div class="sp-ext-card__label">
                {{ landingLang === 'ar' ? 'شركات إضافية' : landingLang === 'he' ? 'חברות נוספות' : 'extra companies' }}
              </div>
              <div class="sp-ext-card__price">₪{{ plan.price | number:'1.0-0' }}</div>
              <a class="sp-btn sp-btn--outline-blue w-100 mt-2" [routerLink]="registerLink">
                {{ t.hero.ctaPrimary }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- SECTION: AI expense token packs                       -->
    <!-- ══════════════════════════════════════════════════════ -->
    <section
      class="sp-section sp-section--ai-bg"
      *ngIf="!plansLoading && !plansError && tokenExtensionPlans.length > 0"
    >
      <div class="sp-section-inner">
        <div class="sp-section-header">
          <div class="sp-section-icon sp-section-icon--ai">
            <i class="fa fa-magic"></i>
          </div>
          <div>
            <h2 class="sp-section-title">
              {{ landingLang === 'ar'
                ? 'تحليل المصاريف بالذكاء الاصطناعي'
                : landingLang === 'he'
                  ? 'ניתוח הוצאות בינה מלאכותית'
                  : 'AI Expense Analysis' }}
              <span class="sp-ai-badge">AI</span>
            </h2>
            <p class="sp-section-desc">
              {{ landingLang === 'ar'
                ? 'ارفع الفواتير والإيصالات — الذكاء الاصطناعي يستخرج ويصنّف ويحلل مصاريفك تلقائيًا. وفّر ساعات من الإدخال اليدوي.'
                : landingLang === 'he'
                  ? 'העלה קבלות וחשבוניות — ה-AI שלנו מחלץ, מסווג ומנתח את ההוצאות שלך אוטומטית. חסוך שעות של הזנה ידנית.'
                  : 'Upload receipts and invoices — our AI automatically extracts, categorizes and analyzes your expenses. Save hours of manual data entry.' }}
            </p>
          </div>
        </div>

        <!-- Feature chips -->
        <div class="sp-ai-features-strip mb-4">
          <div class="sp-ai-feature">
            <i class="fa fa-camera"></i>
            <span>{{ landingLang === 'ar' ? 'مسح OCR ذكي' : landingLang === 'he' ? 'סריקת OCR חכמה' : 'Smart OCR scanning' }}</span>
          </div>
          <div class="sp-ai-feature">
            <i class="fa fa-tags"></i>
            <span>{{ landingLang === 'ar' ? 'تصنيف تلقائي' : landingLang === 'he' ? 'סיווג אוטומטי' : 'Auto-categorization' }}</span>
          </div>
          <div class="sp-ai-feature">
            <i class="fa fa-bar-chart"></i>
            <span>{{ landingLang === 'ar' ? 'تحليل الإنفاق' : landingLang === 'he' ? 'תובנות הוצאות' : 'Spending insights' }}</span>
          </div>
          <div class="sp-ai-feature">
            <i class="fa fa-bolt"></i>
            <span>{{ landingLang === 'ar' ? 'معالجة فورية' : landingLang === 'he' ? 'עיבוד מיידי' : 'Instant processing' }}</span>
          </div>
        </div>

        <div class="row g-4 justify-content-center">
          <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of tokenExtensionPlans; let i = index; trackBy: trackByAddonId">
            <div class="sp-expense-card" [class.sp-expense-card--featured]="i === 1">
              <div class="sp-expense-card__ai-tag"><i class="fa fa-magic"></i> AI</div>
              <h4 class="sp-expense-card__name">{{ addonDisplayName(plan) }}</h4>
              <p class="sp-expense-card__desc" *ngIf="addonDesc(plan)">{{ addonDesc(plan) }}</p>
              <div class="sp-expense-card__quota">
                <span class="sp-expense-card__quota-num">{{ plan.extra_tokens ?? plan.documents_count | number }}</span>
                <span class="sp-expense-card__quota-label">
                  {{ landingLang === 'ar' ? 'توكنات تحليل إضافية' : landingLang === 'he' ? 'טוקני ניתוח נוספים' : 'Extra analysis tokens' }}
                </span>
              </div>
              <div class="sp-expense-card__price">
                <span class="sp-expense-card__currency">₪</span>
                <span class="sp-expense-card__amount">{{ plan.price | number:'1.0-0' }}</span>
                <span class="sp-expense-card__period">/ {{ landingLang === 'ar' ? 'الباقة' : landingLang === 'he' ? 'חבילה' : 'package' }}</span>
              </div>
              <a class="sp-btn sp-btn--solid w-100 mt-3" [routerLink]="registerLink">
                {{ t.hero.ctaPrimary }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="py-24 relative overflow-hidden bg-secondary/30">
      <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div class="w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px]"></div>
      </div>
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-3xl mx-auto text-center">
          <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">{{ t.cta.ready }}</h2>
          <p class="text-lg md:text-xl text-muted-foreground mb-10">{{ t.cta.readyDesc }}</p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <a [routerLink]="registerLink" class="thi-btn-primary-xl group">
              {{ t.hero.ctaPrimary }}
              <i class="transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1" [ngClass]="arrowIcon"></i>
            </a>
            <a routerLink="/support" class="thi-btn-outline-xl">{{ t.hero.ctaSecondary }}</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</app-thi-page-shell>
